import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=75a9193c"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a9193c')) {
      api.createRecord('75a9193c', component.options)
    } else {
      api.reload('75a9193c', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=75a9193c", function () {
      api.rerender('75a9193c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/footer/TheFooter.vue"
export default component.exports